import React, { Component } from 'react';
import '../App.css';
import {Link} from 'react-router-dom';
/* global moment */

export default class Feed extends Component {
  render() {
    let render_posts = [];
    let cat = '';
    let path = window.location.pathname.split('/')
    if (path[1].toLowerCase() === 'category'){
      cat = path[2].toLowerCase();
    }
    
    let posts_info = this.props.app_state.posts_info;
    let this_post = {};
    let num_comm = 0;
    for (var i = 0; i < posts_info.length; i++){
      this_post = posts_info[i];
      num_comm = this_post.num_comments;
      
      if ((cat !== '' && cat !== (this_post.category||'').toLowerCase()) 
            && !(cat === 'miscellaneous' && typeof this_post.category === 'undefined'))
        continue;
      render_posts.push(
        <Link to={"/post/"+this_post.id}>
          <div id={this_post.id} className="feed_post_container">
            <p className="feed_post_title">{this_post.title}</p>
            <t className="feed_time">{moment(this_post.pub_time).fromNow()} </t>
            <t className="text-muted">{(num_comm===0)?'No':num_comm} Comment{num_comm===1?'':'s'}</t>
            <Link to={"/user/"+this_post.author}>
              <t className="feed_author">
                - {(this_post.author_name||this_post.author||'').substring(0,1).toUpperCase() + (this_post.author_name||this_post.author||'').substring(1)}
              </t>
            </Link>
          </div>
        </Link>
      );
      render_posts.push(<hr/>);
    }
    render_posts.pop();
    
    if (render_posts.length === 0) {
      if (this.props.app_state.posts_info_loaded)
        render_posts = <h5>No Posts Found.</h5>;
      else
        render_posts = <h5 className="text-muted">Loading...</h5>;
    }
    
    return (
      <div className="feed_div">
        <img id="relev_img" src="/images/relevant-to-you.png" 
                    alt="relevant to you?"/>
        <div id="feed_container">
          {render_posts}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Feed.js